<template>
  <pagefra
    v-loading.fullscreen="deriveLoading"
    element-loading-text="生成中..."
  >
    <div class="report-box" id="elevator-daily" v-loading.fullscreen="loading">
      <div class="report-item-box">
        <div class="report-title">
          <div class="title-l">
            <label
              class="back"
              v-if="!deriveLoading"
              @click="$router.replace({ path: '/report/elevator' })"
              ><i class="el-icon-arrow-left"></i>{{ $l("返回") }}
            </label>
            <strong>{{ $l("电梯基本信息") }} </strong>
          </div>
          <div class="title-r">
            <el-button
              type="primary"
              round
              v-if="!form.reportId || form.reportStatus == 1"
              @click="handleDefault"
              :loading="saveLoading"
              class="download"
              >{{ $l("一键确认") }}
            </el-button>
            <el-button
              type="primary"
              round
              v-if="!form.reportId || form.reportStatus == 1"
              @click="handleSaveForm(1)"
              :loading="saveLoading"
              >{{ $l("保存草稿") }}
            </el-button>
            <el-button
              type="primary"
              round
              v-if="!form.reportId || form.reportStatus == 1"
              @click="handleSaveForm(2)"
              :loading="saveLoading"
              >{{ $l("提交") }}
            </el-button>
            <el-button
              type="primary"
              round
              v-else-if="!deriveLoading"
              @click="handleDerive"
              class="download"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
        <div class="content-box">
          <div class="info-box">
            <div class="code-item">
              <span>{{ $l("所在城市：") }} {{ $l(form.city) }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("地盘名称：") }} {{ form.domainName }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("大楼名称：") }} {{ form.buildingName }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("梯号：") }} {{ form.elevatorNum }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("工号：") }} {{ form.jobNum }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("注册代码：") }} {{ form.registerCode }}</span>
            </div>
            <div class="code-item">
              <span
                >{{ $l("报告确认时间：") }}
                {{
                  (form.confirmTime && form.confirmTime.split(" ")[0]) ||
                  params.confirmTime.split(" ")[0]
                }}</span
              >
            </div>
            <div class="code-item">
              <span class="ti-input" v-if="!readonly"
                >{{ $l("安全员/安全总监：") }}
                <el-select
                  v-model="form.adminName"
                  :placeholder="$l('请选择')"
                  filterable
                  :disabled="readonly"
                  style="width: 150px"
                >
                  <el-option
                    v-for="item in whiteListOptions"
                    :key="item.userName"
                    :label="item.userName"
                    :value="item.userName"
                  ></el-option>
                </el-select>
              </span>
              <span class="ti-input" v-else
                >{{ $l("安全员/安全总监：") }} {{ form.adminName }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="report-item-box"
        v-if="form.indexList && form.indexList.length"
      >
        <div class="content-box">
          <el-table
            class="index-table"
            :data="indexTableRows"
            border
            :span-method="getIndexTableSpan"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('检查部位')"
              min-width="130"
              align="center"
            >
              <template slot-scope="scope">
                {{ $l(scope.row.section.name) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('检查内容')"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                {{ $l(scope.row.item.name) }}
              </template>
            </el-table-column>
            <el-table-column :label="$l('结果')" min-width="150" align="center">
              <template slot-scope="scope">
                <el-input
                  v-if="
                    !deriveLoading &&
                    !readonly &&
                    scope.row.item.vType === 'input'
                  "
                  v-model="scope.row.item.value"
                  :placeholder="$l('请输入')"
                >
                  <div class="unit" slot="suffix" v-if="scope.row.item.unit">
                    <span>{{ $l(scope.row.item.unit) }} </span>
                  </div>
                </el-input>
                <el-select
                  v-else-if="
                    !deriveLoading &&
                    !readonly &&
                    scope.row.item.vType === 'select'
                  "
                  v-model="scope.row.item.value"
                  :placeholder="$l('请选择')"
                >
                  <el-option
                    v-for="(opt, oi) in scope.row.item.vListOptions"
                    :key="oi"
                    :label="opt.name"
                    :value="opt.value"
                  ></el-option>
                </el-select>
                <span v-else class="result-text"
                  >{{ getDisplayValue(scope.row.item) }}
                  <span v-if="scope.row.item.unit">{{
                    $l(scope.row.item.unit)
                  }}</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="section-bottom-box">
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检拍照情况") }} </strong>
            </div>
            <div class="title-r">
              <div style="display: flex">
                <el-upload
                  multiple
                  action=""
                  v-if="!form.reportId || form.reportStatus == 1"
                  :limit="6"
                  :show-file-list="false"
                  :http-request="handleUploading"
                  accept="image/*"
                >
                  <el-button type="primary" class="uploading" round
                    >{{ $l("上传") }}
                  </el-button>
                </el-upload>
                <el-button
                  v-else-if="files.length != 0 && !deriveLoading"
                  type="primary"
                  class="download"
                  round
                  @click="clickDownloadImg"
                  >{{ $l("下载") }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <div class="img-item" v-for="(t, i) in files" :key="i">
                <img :src="t.url" />
                <div class="o">
                  <span
                    @click="imgDeleteView(1, i)"
                    v-if="!form.reportId || form.reportStatus == 1"
                    >{{ $l("删除") }}
                  </span>
                  <span @click="imgDeleteView(0, i)" v-if="!deriveLoading"
                    >{{ $l("预览") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检日志说明") }} </strong>
            </div>
            <div class="title-r">
              <el-button
                type="primary"
                class="clar"
                round
                @click="form.remark = ''"
                v-if="
                  (!form.reportId || form.reportStatus == 1) && !deriveLoading
                "
                >{{ $l("清空") }}
              </el-button>
              <!-- <el-button type="primary" class="download" round>确定</el-button> -->
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <el-input
                v-if="!form.reportId || form.reportStatus == 1"
                type="textarea"
                maxlength="200"
                resize="none"
                :readonly="readonly"
                v-model="form.remark"
              >
              </el-input>
              <p v-else>{{ form.remark }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="report-item-box" v-if="files.length > 0 && deriveLoading">
        <div class="report-title">
          <div class="title-l">
            <strong>巡检拍照图片详情</strong>
          </div>
        </div>
        <div class="content-box">
          <div class="bigimg">
            <img :src="t.url" v-for="(t, i) in files" :key="i" />
          </div>
        </div>
      </div>
      <el-image-viewer
        v-if="showViewer"
        :url-list="viewfiles"
        :on-close="closeViewer"
      >
      </el-image-viewer>
      <div class="signature-area">
        <div class="sign-title-bar">
          <span class="sign-title">{{ $l("巡检人员签名") }}</span>
          <el-button
            v-if="!form.reportId || form.reportStatus == 1"
            type="primary"
            round
            size="small"
            @click="signVisible = true"
            class="sign-btn"
          >
            {{ signatureImg ? $l("重新签名") : $l("签名") }}
          </el-button>
        </div>
        <div class="sign-body">
          <img v-if="signatureImg" :src="signatureImg" class="sign-img" />
        </div>
      </div>
      <sign-dialog
        :visible.sync="signVisible"
        @confirm="onSignConfirm"
      ></sign-dialog>
    </div>
  </pagefra>
</template>
<script>
import dayjs from "dayjs";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import global from "@/mixins/global.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import signDialog from "@/components/signDialog.vue";
import { mapGetters } from "vuex";
export default {
  mixins: [global],
  data() {
    return {
      params: {},
      files: [],
      signatureImg: "",
      isSignature: false,
      signVisible: false,
      showViewer: false,
      form: {
        files: [],
      },
      loading: false,
      saveLoading: false,
      showDerive: false,
      whiteListOptions: [],
    };
  },
  components: { ElImageViewer, signDialog },
  computed: {
    ...mapGetters(["deriveLoading"]),
    viewfiles() {
      return this.files.map((v) => v.url);
    },
    readonly() {
      return this.form.reportId && this.form.reportStatus == 2 ? true : false;
    },
    indexTableRows() {
      const rows = [];
      (this.form.indexList || []).forEach((section) => {
        const childrens = section.childrens || [];
        childrens.forEach((item, i) => {
          rows.push({
            section: section,
            item: item,
            span: i === 0 ? childrens.length : 0,
          });
        });
      });
      return rows;
    },
  },
  created() {
    const { query } = this.$route;
    this.params = query;
    if (query.confirmTime) {
      this.$route.meta.subtitle = `（${dayjs(query.confirmTime).format(
        "YYYY年M月D日"
      )}）`;
    }
    this.loadReportData();
    if (!this.form.reportId || this.form.reportStatus == 1) {
      this.loadWhiteList();
    }
  },
  methods: {
    /* 加载白名单列表 */
    loadWhiteList() {
      this.$http
        .get(this.$apiConfig.get_elevator_inspection_white_list)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.whiteListOptions = result.data || [];
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    /* 加载字段详情 */
    loadReportData() {
      this.loading = true;
      this.$http
        .get(this.$apiConfig.get_report_detail, {
          params: {
            reportId: this.params.reportId,
            jobNum: this.params.jobNum,
            confirmTime: this.params.confirmTime,
          },
        })
        .then((response) => {
          let result = response.data;
          this.loading = false;
          if (result.code == 0) {
            result.data.files = result.data.files || [];
            result.data.images = result.data.images || [];
            result.data.indexList = (result.data.indexList || []).map(
              (section) => {
                const childrens = (section.childrens || []).map((item) =>
                  Object.assign({}, item, {
                    value: item.value != null ? item.value : "",
                    vListOptions: this.parseVListOptions(item.vList),
                  })
                );
                return Object.assign({}, section, { childrens });
              }
            );
            this.form = result.data;
            if (!this.params.reportId) {
              this.form.adminName = "";
            }
            this.files = result.data.images.map((v) => {
              return {
                url: result.data.resourceServerUrl + v.imageUrl,
                image: v,
              };
            });
            this.signatureImg = result.data.signatureUrl
              ? result.data.resourceServerUrl + result.data.signatureUrl
              : "";
            this.isSignature = false;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    /* 图片上传 */
    handleUploading(file) {
      this.files.push({
        file: file.file,
        url: URL.createObjectURL(file.file),
      });
    },
    imgDeleteView(type, index) {
      if (type) {
        this.files.splice(index, 1);
      } else {
        this.showViewer = true;
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    onSignConfirm(img) {
      this.signatureImg = img;
      this.isSignature = true;
    },
    /* 保存 */
    handleSaveForm(reportStatus) {
      const isDraft = reportStatus == 1;
      if (!isDraft && !this.form.adminName) {
        return this.$message(this.$l("请选择安全员/安全总监！"));
      }
      if (!isDraft && !this.signatureImg) {
        return this.$message(this.$l("请先进行签名"));
      }
      if (
        !isDraft &&
        (this.form.indexList || []).some((section) =>
          (section.childrens || []).some(
            (item) =>
              (item.vType === "input" || item.vType === "select") &&
              (item.value == null || String(item.value).trim() === "")
          )
        )
      ) {
        return this.$message(this.$l("存在指标项未填写！"));
      }
      this.$confirm(
        !this.form.remark
          ? this.$l("巡检日志说明未填写是否继续提交?")
          : this.$l("确认提交吗?"),
        this.$l(isDraft ? "保存草稿" : "提交日报"),
        {
          type: "warning",
        }
      )
        .then(() => {
          let fileData = new FormData();
          this.form.reportStatus = reportStatus;
          for (const k in this.form) {
            if (k === "indexList") {
              if (this.form[k] && this.form[k].length) {
                fileData.append(
                  "indexJson",
                  JSON.stringify(
                    this.form[k].map((section) =>
                      Object.assign({}, section, {
                        childrens: (section.childrens || []).map((item) => {
                          const copy = Object.assign({}, item);
                          delete copy.vListOptions;
                          return copy;
                        }),
                      })
                    )
                  )
                );
              }
            } else if (
              !["files", "images", "indexJson"].includes(k) &&
              this.form[k] != null
            ) {
              fileData.append(k, this.form[k]);
            }
          }
          this.files.forEach((v, i) => {
            if (!v.image) {
              fileData.append("files", v.file);
            } else {
              fileData.append("images[" + i + "].imageId", v.image.imageId);
            }
          });
          if (this.signatureImg && this.isSignature) {
            const signFile = this.dataURLtoFile(
              this.signatureImg,
              "signature.png"
            );
            fileData.append("signature", signFile);
          }
          this.saveLoading = true;
          this.$http
            .post(this.$apiConfig.save_elevator_inspection_report, fileData)
            .then((response) => {
              let result = response.data;
              this.saveLoading = false;
              if (result.code == 0) {
                this.message(result.code, result.msg);
                this.form.reportId = response.data.data;
                sessionStorage.setItem("submit_report_success", "refresh");
              } else {
                this.message(result.code, result.msg);
              }
            })
            .catch((error) => {
              this.saveLoading = false;
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      const n = bstr.length;
      const u8arr = new Uint8Array(n);
      for (let i = 0; i < n; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }
      return new File([u8arr], filename, { type: mime });
    },
    /* a标签下载图片 */
    clickDownloadImg() {
      this.files.forEach((v, i) => {
        const image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          const url = canvas.toDataURL("image/jpg"); // 图片 base64
          const a = document.createElement("a");
          a.download = "巡检图片_" + (i + 1) + ".jpg";
          a.href = url;
          const event = new MouseEvent("click");
          a.dispatchEvent(event);
        };
        image.src =
          v.url +
          (v.url.indexOf("?") > -1 ? "&time=" : "?time=") +
          new Date().valueOf();
      });
    },
    handleDefault() {
      const nullCode = [
        "registerCode",
        "jobNumList",
        "elevatorDataList",
        "startDate",
        "endDate",
        "signatureUrl",
        "signature",
      ];
      for (const k in this.form) {
        if (this.form[k] == null && k !== "indexList") {
          this.form[k] = nullCode.includes(k) ? null : "";
        }
      }
      (this.form.indexList || []).forEach((section) => {
        (section.childrens || []).forEach((item) => {
          if (
            (item.value == null || item.value === "") &&
            item.defaultValue != null &&
            item.defaultValue !== ""
          ) {
            let def = item.defaultValue;
            if (item.vType === "select" && item.vListOptions.length) {
              const opt = item.vListOptions.find(
                (o) => String(o.value) === String(def)
              );
              if (opt) {
                def = opt.value;
              }
            }
            item.value = def;
          }
        });
      });
    },
    /* 导出 */
    handleDerive() {
      this.$store.commit("setDeriveLoading", true);
      this.$nextTick(() => {
        const reportBox = document.getElementById("elevator-daily");
        const pageFraMain = document.getElementsByClassName("pagefra-main")[0];
        const elMain = pageFraMain.querySelector(".el-main");
        const scrollHeight = reportBox.scrollHeight;
        reportBox.style.height = scrollHeight + 120 + "px";
        if (elMain) elMain.style.overflow = "visible";
        pageFraMain.style.height = scrollHeight + 120 + "px";
        pageFraMain.style.overflow = "visible";
        const images = reportBox.querySelectorAll(".bigimg img, .img-item img");
        const promises = Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        });
        Promise.all(promises).then(() => {
          html2canvas(pageFraMain, {
            useCORS: true,
            backgroundColor: "#fff",
            scale: 2,
          })
            .then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF("p", "mm", "a4");
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const imgHeight = (canvas.height * pdfWidth) / canvas.width;
              if (imgHeight > pdf.internal.pageSize.getHeight()) {
                const customPdf = new jsPDF({
                  orientation: "p",
                  unit: "mm",
                  format: [pdfWidth, imgHeight + 10],
                });
                customPdf.addImage(imgData, "PNG", 0, 0, pdfWidth, imgHeight);
                customPdf.save(
                  this.$route.meta.title +
                    this.$route.meta.subtitle +
                    "_" +
                    (this.form.registerCode ? this.form.registerCode : "") +
                    ".pdf"
                );
              } else {
                pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, imgHeight);
                pdf.save(
                  this.$route.meta.title +
                    this.$route.meta.subtitle +
                    "_" +
                    (this.form.registerCode ? this.form.registerCode : "") +
                    ".pdf"
                );
              }
              reportBox.style.height = "auto";
              if (elMain) elMain.style.overflow = "";
              pageFraMain.style.overflow = "";
              pageFraMain.style.height = "auto";
              this.$store.commit("setDeriveLoading", false);
            })
            .catch(() => {
              reportBox.style.height = "auto";
              if (elMain) elMain.style.overflow = "";
              pageFraMain.style.overflow = "";
              pageFraMain.style.height = "auto";
              this.$store.commit("setDeriveLoading", false);
              this.message(500, this.$l("导出失败"));
            });
        });
      });
    },
    /* 指标表格检查部位列合并单元格 */
    getIndexTableSpan({ row, columnIndex }) {
      if (columnIndex === 1) {
        return row.span
          ? { rowspan: row.span, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    /* 解析指标项下拉选项 */
    parseVListOptions(str) {
      if (typeof str === "string" && str.trim()) {
        try {
          const list = JSON.parse(str);
          if (Array.isArray(list)) {
            return list.map((item) => ({
              name: (item && item.name) || "",
              value: item && item.value != null ? item.value : "",
            }));
          }
        } catch (e) {
          this.$sentry.captureException(e);
        }
      }
      return [];
    },
    /* 只读/导出时获取指标项显示文本 */
    getDisplayValue(item) {
      const v = item.value;
      if (v == null || v === "") return "";
      if (item.vType === "select") {
        const opt = (item.vListOptions || []).find((o) => o.value === v);
        if (opt) {
          return opt.name;
        }
      }
      return v;
    },
  },
};
</script>
<style></style>
<style scoped lang="scss">
.report-box {
  padding: 20px;
  background: #f0f1f2;
}
.report-item-box {
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #c7c7c7;
  margin-bottom: 18px;
  .report-title {
    height: 66px;
    padding: 15px 20px;
    border-bottom: 1px solid #c7c7c7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-l {
      color: #5c5c5c;
      strong {
        font-size: 18px;
        font-weight: 700;
        margin-right: 10px;
      }
    }
  }
  .content-box {
    padding: 15px 20px;
    span,
    label {
      font-size: 14px;
      color: #5c5c5c;
    }
  }
}
.index-table {
  /deep/.el-table__cell {
    padding: 6px 0;
  }
  /deep/.el-input,
  /deep/.el-select {
    width: 130px;
    .el-input__inner {
      font-size: 14px;
      color: #35b6ae;
    }
  }
  .unit {
    display: flex;
    align-items: center;
    height: 100%;
    margin-right: 5px;
  }
}
.info-box {
  display: flex;
  flex-wrap: wrap;
  .code-item {
    width: 25%;
    line-height: 2.5;
  }
}
.section-bottom-box {
  display: flex;
  margin-top: 18px;
  gap: 18px;
  & > div {
    width: calc(50% - 9px);
    flex-shrink: 0;
    .report-item-box {
      margin-bottom: 0;
    }
  }
}
.uploading {
  background-color: #ff6969;
  border-color: #ff6969;
}
.download {
  margin-left: 20px;
  background-color: #35b6ae;
  border-color: #35b6ae;
}
.clar {
  background-color: #808396;
  border-color: #808396;
}
.explain-box {
  height: auto;
  min-height: 120px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  row-gap: 10px;
  /deep/.el-textarea {
    height: 100%;
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .img-item {
    width: 100px;
    margin-right: 20px;
    img {
      width: 100px;
      height: 100px;
    }
    .o {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #ff5733;
        cursor: pointer;
      }
      span:last-child {
        color: #07a89e;
      }
    }
  }
}
.bigimg {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  img {
    height: 450px;
    width: calc(33.33% - 10px);
    margin-bottom: 20px;
    object-fit: contain;
    object-position: center;
  }
  img:not(:last-child) {
    margin-right: 10px;
  }
}
.result-text {
  font-size: 14px;
  color: #35b6ae;
  min-width: 0;
  overflow-wrap: break-word;
}
.ti-input {
  display: flex;
  align-items: center;
  .el-input,
  .el-select {
    width: 100px;
  }
}
.back {
  margin-right: 15px;
  cursor: pointer;
}
.signature-area {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #c7c7c7;
  .sign-title-bar {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .sign-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
    .sign-btn {
      background-color: #35b6ae;
      border-color: #35b6ae;
      color: #fff;
    }
  }
  .sign-body {
    padding: 0 20px 20px;
    .sign-img {
      max-height: 80px;
      max-width: 200px;
      border: 1px dashed #dcdfe6;
      border-radius: 4px;
      padding: 4px;
      background: #fafafa;
    }
  }
}
</style>
